"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Z_INDEX_ABOVE_GOOGLE_PICKER = exports.Betas = exports.MAX_LENGTH_WARNING_THRESHOLD = exports.MAX_SUMMARY_LENGTH = exports.MAX_TITLE_LENGTH = exports.TRACK_EVENT_META_KEY = exports.AmplitudeEvents = exports.TrackEventTypes = exports.CHANGE_EDITOR_CHANGE_TYPE = exports.CONNECT_INBOX_REQUEST_GROUP = exports.ONE_AND_A_HALF_SECONDS_IN_MS = exports.BlogUserAttributes = exports.TERMS_AND_CONDITIONS_URL = exports.ACCESS_GRANTED_TOAST_ID = exports.PRESENCE_RELATIONSHIPS = exports.LOCK_TOAST_ID = exports.EDITOR_CHANGE_TYPES = exports.REVISIONS_LIST_CLASSNAME = exports.NO_BLUR_TARGETS = exports.EDITORS_GROUP_CLASSNAME = exports.BODY_EDITOR_CLASSNAME = exports.EDITORS_CONTAINER_CLASSNAME = exports.SUMMARY_ID = exports.TITLE_ID = exports.DRAFT_CANCELLABLE_HANDLERS = exports.CHANGE_ENTITY_TYPE = exports.SUMMARY_BLOCK_KEY = exports.TITLE_BLOCK_KEY = exports.UPDATE_COMPOSITION_FIELDS = exports.KeyCommands = exports.ProcessingStatus = exports.ApiFields = exports.GATES = exports.GOOGLE_DRIVE_GATE = exports.MethodTypes = exports.RealtimeTargetTypes = exports.RealtimePresenceTypes = exports.MessageTypes = exports.RequestStatus = exports.DEFAULT_RICH_TEXT_STYLES = exports.DEFAULT_COMPOSER_FEATURES = exports.RICH_TEXT_STYLES = exports.ComposerFeatures = exports.CompositionOrigin = exports.CompositionTypes = void 0;

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _constants = require("composer-plugins/lib/constants");

var CompositionTypes = {
  BLOG_POST: 3,
  KNOWLEDGE_ARTICLE: 6,
  PLAYBOOK: 100
};
exports.CompositionTypes = CompositionTypes;
var CompositionOrigin = {
  BLOG_POST: 0,
  KNOWLEDGE_ARTICLE: 1,
  PLAYBOOK: 2
};
exports.CompositionOrigin = CompositionOrigin;
var ComposerFeatures = {
  CHANGE: 'change',
  CLIP: 'clip',
  CONVERSATIONS: 'conversations',
  GOOGLE_DOCS: 'google-docs',
  IMAGE: 'image',
  IMAGE_V2: 'image-v2',
  LINK: 'link',
  PRESENCE: 'presence',
  REVISIONS: 'revisions',
  VIDEO: 'video',
  EMBED: 'embed',
  QUESTION_AND_ANSWER: 'question-and-answer-content'
};
exports.ComposerFeatures = ComposerFeatures;
var RICH_TEXT_STYLES = {
  INLINE_STYLES: {
    INCLUDED_STYLES: {
      BOLD: 'BOLD',
      ITALIC: 'ITALIC'
    }
  },
  BLOCK_STYLES: {
    HEADER_STYLES: {
      HEADER_ONE: 'header-one',
      HEADER_TWO: 'header-two',
      HEADER_THREE: 'header-three',
      HEADER_FOUR: 'header-four',
      HEADER_FIVE: 'header-five'
    },
    LIST_STYLES: {
      ORDERED_LIST_ITEM: 'ordered-list-item',
      UNORDERED_LIST_ITEM: 'unordered-list-item'
    },
    MISC_STYLES: {
      BLOCKQUOTE: 'blockquote',
      CODE_BLOCK: 'code-block'
    }
  }
};
exports.RICH_TEXT_STYLES = RICH_TEXT_STYLES;
var DEFAULT_COMPOSER_FEATURES = [ComposerFeatures.CHANGE, ComposerFeatures.IMAGE, ComposerFeatures.IMAGE_V2, ComposerFeatures.LINK, ComposerFeatures.PRESENCE, ComposerFeatures.VIDEO];
exports.DEFAULT_COMPOSER_FEATURES = DEFAULT_COMPOSER_FEATURES;
var DEFAULT_RICH_TEXT_STYLES = {
  INLINE_STYLES: [RICH_TEXT_STYLES.INLINE_STYLES.INCLUDED_STYLES.BOLD, RICH_TEXT_STYLES.INLINE_STYLES.INCLUDED_STYLES.ITALIC],
  BLOCK_STYLES: [RICH_TEXT_STYLES.BLOCK_STYLES.LIST_STYLES.UNORDERED_LIST_ITEM, RICH_TEXT_STYLES.BLOCK_STYLES.LIST_STYLES.ORDERED_LIST_ITEM, RICH_TEXT_STYLES.BLOCK_STYLES.HEADER_STYLES.HEADER_TWO, RICH_TEXT_STYLES.BLOCK_STYLES.HEADER_STYLES.HEADER_THREE, RICH_TEXT_STYLES.BLOCK_STYLES.MISC_STYLES.BLOCKQUOTE]
};
exports.DEFAULT_RICH_TEXT_STYLES = DEFAULT_RICH_TEXT_STYLES;
var RequestStatus = (0, _keyMirror.default)({
  UNINITIALIZED: null,
  PENDING: null,
  SUCCEEDED: null,
  FAILED: null
});
exports.RequestStatus = RequestStatus;
var MessageTypes = {
  ERROR: 'error',
  WARN: 'warn',
  INFO: 'info',
  SUCCESS: 'success'
};
exports.MessageTypes = MessageTypes;
var RealtimePresenceTypes = {
  ENTER: 'enter',
  LEAVE: 'leave',
  UPDATE: 'update',
  PRESENT: 'present'
};
exports.RealtimePresenceTypes = RealtimePresenceTypes;
var RealtimeTargetTypes = {
  CONTENT: 0,
  COMPOSITION: 1,
  CONVERSATION: 2,
  COMMENT: 3,
  LOCK: 4,
  LOCK_REQUEST: 5,
  LOCK_REQUEST_REJECTION: 6
};
exports.RealtimeTargetTypes = RealtimeTargetTypes;
var MethodTypes = {
  CREATE: 'POST',
  DELETE: 'DELETE',
  UPDATE: 'PATCH'
};
exports.MethodTypes = MethodTypes;
var GOOGLE_DRIVE_GATE = 'cos_blog_googledrive';
exports.GOOGLE_DRIVE_GATE = GOOGLE_DRIVE_GATE;
var GATES = ['cos_blog_beta', 'cos_blog_beta_optedout', 'cos_blog_collect_beta', 'cos_blog_compose_clip_gallery', GOOGLE_DRIVE_GATE, _constants.OPEN_EMBED_GATE];
exports.GATES = GATES;
var ApiFields = ['composeBody', 'id', 'processingStatus'];
exports.ApiFields = ApiFields;
var ProcessingStatus = {
  COMPOSING: 'composing',
  FORMATTING: 'formatting'
};
exports.ProcessingStatus = ProcessingStatus;
var KeyCommands = {
  DELETE_IMAGE: 'delete-image'
};
exports.KeyCommands = KeyCommands;
var UPDATE_COMPOSITION_FIELDS = ['body', 'id', 'lockedSession', 'summary', 'title'];
exports.UPDATE_COMPOSITION_FIELDS = UPDATE_COMPOSITION_FIELDS;
var TITLE_BLOCK_KEY = 'TITLE_BLOCK_KEY';
exports.TITLE_BLOCK_KEY = TITLE_BLOCK_KEY;
var SUMMARY_BLOCK_KEY = 'SUMMARY_BLOCK_KEY';
exports.SUMMARY_BLOCK_KEY = SUMMARY_BLOCK_KEY;
var CHANGE_ENTITY_TYPE = 'CHANGE';
exports.CHANGE_ENTITY_TYPE = CHANGE_ENTITY_TYPE;
var DRAFT_CANCELLABLE_HANDLERS = {
  HANDLED: 'handled',
  NOT_HANDLED: 'not-handled'
};
exports.DRAFT_CANCELLABLE_HANDLERS = DRAFT_CANCELLABLE_HANDLERS;
var TITLE_ID = 'composition-title';
exports.TITLE_ID = TITLE_ID;
var SUMMARY_ID = 'composition-summary';
exports.SUMMARY_ID = SUMMARY_ID;
var EDITORS_CONTAINER_CLASSNAME = 'editors-container';
exports.EDITORS_CONTAINER_CLASSNAME = EDITORS_CONTAINER_CLASSNAME;
var BODY_EDITOR_CLASSNAME = 'composition-body-container';
exports.BODY_EDITOR_CLASSNAME = BODY_EDITOR_CLASSNAME;
var EDITORS_GROUP_CLASSNAME = 'composition-container';
exports.EDITORS_GROUP_CLASSNAME = EDITORS_GROUP_CLASSNAME;
var NO_BLUR_TARGETS = [BODY_EDITOR_CLASSNAME, EDITORS_GROUP_CLASSNAME];
exports.NO_BLUR_TARGETS = NO_BLUR_TARGETS;
var REVISIONS_LIST_CLASSNAME = 'revisions-list-container';
exports.REVISIONS_LIST_CLASSNAME = REVISIONS_LIST_CLASSNAME;
var EDITOR_CHANGE_TYPES = {
  insertImage: 'insert-image',
  insertImageClip: 'insert-clip-image',
  insertLinkClip: 'insert-clip-link',
  insertQuoteClip: 'insert-clip-quote',
  insertClip: 'insert-clip',
  insertVideo: 'insert-video',
  insertEmbed: 'insert-embed',
  questionAndAnswer: 'insert-question-and-answer'
};
exports.EDITOR_CHANGE_TYPES = EDITOR_CHANGE_TYPES;
var LOCK_TOAST_ID = 'other-user-lock';
exports.LOCK_TOAST_ID = LOCK_TOAST_ID;
var PRESENCE_RELATIONSHIPS = {
  COMMENTER_TO_COMMENTER: 'commenterToCommenter',
  COMMENTER_TO_IDLE_LOCKER: 'commenterToIdleLocker',
  COMMENTER_TO_LOCKER: 'commenterToLocker',
  LOCKER: 'locker',
  REQUESTER_TO_LOCKER: 'requesterToLocker'
};
exports.PRESENCE_RELATIONSHIPS = PRESENCE_RELATIONSHIPS;
var ACCESS_GRANTED_TOAST_ID = 'ACCESS-GRANTED-TOAST';
exports.ACCESS_GRANTED_TOAST_ID = ACCESS_GRANTED_TOAST_ID;
var TERMS_AND_CONDITIONS_URL = 'https://legal.hubspot.com/terms-of-service';
exports.TERMS_AND_CONDITIONS_URL = TERMS_AND_CONDITIONS_URL;
var BlogUserAttributes = {
  CLIP_IMAGE_LEGAL_CHECK: 'blog:clip-image-legal-check',
  INSERT_TOOLS_DEPRECATION_NOTICE: 'blog:insert-tools-deprecation-notice-final'
};
exports.BlogUserAttributes = BlogUserAttributes;
var ONE_AND_A_HALF_SECONDS_IN_MS = 1500;
exports.ONE_AND_A_HALF_SECONDS_IN_MS = ONE_AND_A_HALF_SECONDS_IN_MS;
var CONNECT_INBOX_REQUEST_GROUP = 'BLOG_GOOGLE_DRIVE_INTEGRATION';
exports.CONNECT_INBOX_REQUEST_GROUP = CONNECT_INBOX_REQUEST_GROUP;
var CHANGE_EDITOR_CHANGE_TYPE = 'apply-update-change';
exports.CHANGE_EDITOR_CHANGE_TYPE = CHANGE_EDITOR_CHANGE_TYPE;
var TrackEventTypes = (0, _keyMirror.default)({
  INTERACTION: null,
  ERROR: null,
  USAGE: null
});
exports.TrackEventTypes = TrackEventTypes;
var AmplitudeEvents = {
  COMPOSITION_INTERACTION: {
    USAGE: 'compositionInteractionAsUsage',
    INTERACTION: 'compositionInteractionAsInteraction'
  },
  COMPOSITION_COLLABORATION: 'compositionCollaboration'
};
exports.AmplitudeEvents = AmplitudeEvents;
var TRACK_EVENT_META_KEY = '@@usage';
exports.TRACK_EVENT_META_KEY = TRACK_EVENT_META_KEY;
var MAX_TITLE_LENGTH = 200;
exports.MAX_TITLE_LENGTH = MAX_TITLE_LENGTH;
var MAX_SUMMARY_LENGTH = 250;
exports.MAX_SUMMARY_LENGTH = MAX_SUMMARY_LENGTH;
var MAX_LENGTH_WARNING_THRESHOLD = 20;
exports.MAX_LENGTH_WARNING_THRESHOLD = MAX_LENGTH_WARNING_THRESHOLD;
var Betas = (0, _keyMirror.default)({
  LINK_POPOVER: null,
  TOOLBAR: null
});
exports.Betas = Betas;
var GOOGLE_PICKER_Z_INDEX = 20000;
var Z_INDEX_ABOVE_GOOGLE_PICKER = GOOGLE_PICKER_Z_INDEX + 1;
exports.Z_INDEX_ABOVE_GOOGLE_PICKER = Z_INDEX_ABOVE_GOOGLE_PICKER;